import { createAsyncThunk } from '@reduxjs/toolkit'
import { routePaths } from '../../../../../routes/routeConstants'
import { apiEndPoints, apiHeaders, apiMethods } from '../../../../../utils/apiConstants'
import customAxios from '../../../../../utils/customAxios'
import { addUserToLocalStorage, removeUserFromLocalStorage } from '../../../../../utils/utils'

const getAllcountriesList = async (setCountries) => {
	const paras = {
		search: '',
	}

	const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getAllCountries, paras)
	const countries = responseJson.data.data

	setCountries(countries)
}

const getAllstates = async (event, setCountryState) => {
	const paras = {
		search: '',
		countryId: event,
	}
	const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getAllStates, paras)
	const states = responseJson.data.data

	setCountryState(states)
}

const districtChange = async (event, setCountryDistrict) => {
	const paras = {
		search: '',
		stateId: event,
	}
	const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getAllDistricts, paras)
	const countries = responseJson.data.data
	setCountryDistrict(countries)
}

const forgotPassWordThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.forgotPassword, body)
		return responseJson.data
	} catch (error) {
		throw error
	}
}

const forgotPassWord = createAsyncThunk('user/forgotPassWord', forgotPassWordThunk)
const signUserUp = async (navigate, formData, age, isMobile) => {
	// Common fields
	let body = {
		fullName: formData.fullName,
		dob: formData.dob,
		gender: formData.gender,
		age: age, // Calculated age from date of birth
		emailId: formData.emailId,
		countryId: formData.countryId,
		stateId: formData.stateId,
		districtId: formData.districtId,
		mobileNo: formData.mobileNo,
		password: formData.password,
		sponserId: formData.sponserId,
		termsAndConditions: formData.termsAndConditions,
		role: formData?.role,
		city: formData.city,
		zipCode: formData.zipCode,
	}

	// Add role-specific fields
	if (formData?.role === 'organisation') {
		body = {
			...body, // Spread common fields
			designation: formData?.designation,
			authorityName: formData?.authorityName,
			organisationName: formData?.organisationName,
			registeredYear: formData?.registeredYear,
		}
	}

	// Make the API request
	const response = await customAxios[apiMethods.post](apiEndPoints?.signUp, body)

	// Handle response
	if (response?.data?.status === 1) {
		const route = isMobile ? routePaths?.MobileUserSignIn : routePaths?.signIn
		navigate(route)

		// Cleanup timer
	}
}

const particularUserLogin = async (id) => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.signInAsUser(id))
		return responseJson.data
	} catch (error) {
		throw error
	}
}

export { getAllcountriesList, districtChange, getAllstates, signUserUp, forgotPassWord, particularUserLogin }
